/** Function that returns either white or black depending on which has higher contrast with the specified color */
function contrastColor(color) {
    if (!color) {
        return '#000';
    }
    const rgb = color.match(/\d+/g);
    if (!rgb) {
        return '#000';
    }
    const r = parseInt(rgb[0], 10);
    const g = parseInt(rgb[1], 10);
    const b = parseInt(rgb[2], 10);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
}

export { contrastColor as c };
//# sourceMappingURL=theme-22bba55b.js.map
